<div class="wrapper">
    @if (!loading()) {
        <div class="container mt-3 fade-in-left">
            <div class="d-flex align-items-center justify-content-center mb-5 me-4">
                <div class="p-2"><a (click)="volver()"><i class="bi bi-chevron-left align-middle"></i></a></div>
                <div class="p-2 flex-grow-1 pl-2"><h1 class="text-center">Verificar mail</h1></div>
            </div>

            <!-- Sections -->
            <div class="row-cols-12 m-4 mt-5">
                <div class="row p-3">    
                    <div class="description mb-3 mt-0 text-center">
                        Te enviamos un email para activar tu cuenta
                        @if (email()) { a <strong>{{ email() }}</strong> }. 
                        Si no lo encontrás, revisá en la casilla de SPAM.
                    </div>
                </div>
                <hr class="hr border-white opacity-30 mt-4 ms-4 me-4">
                <div class="row p-3 text-center"> 
                    @if (error()) {
                        <div class="alert alert-danger" role="alert"><small>{{ error() }}</small></div>
                    }   
                    @if (canResend()) {
                        <a class="text-link-small" (click)="reenviarVerificarEmail()"
                        [class.disabled]="loading()">Clic acá para enviarlo nuevamente</a>
                    } @else {
                        <span>Podrás reenviar en {{ countdown() }} segundos</span>
                    }
                </div>

                <div class="d-grid mt-2 mb-2"><button type="button" (click)="volver()" class="btn btn-primary btn-lg mt-5">Volver</button></div>
            </div>
        </div>
    }
    @if (loading()) {
        <div class="spinner">
            <div class="spinner-border text-info color-spinner" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    }
</div>